import {getCommentsWrapper} from './tech.blogComments';
import {loadFormValidator} from './tech.core';
global.jQuery = require('jquery');
global.$ = global.jQuery;
const LAZY_LOADING_VERTICAL_OFFSET = 356
var body = $('body')

var wrapper = document.getElementById("comment-wrapper");
if(wrapper){
    if ("IntersectionObserver" in window) {
        var wrapperObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    var lazyCommentWrapper = entry.target;
                    let postId = lazyCommentWrapper.dataset.postId;
                    wrapperObserver.unobserve(lazyCommentWrapper);
                    getCommentsWrapper(postId, function(){
                        loadFormValidator("#commentForm");
                    });
                }
            });
        }, {
            rootMargin: "0px 0px " +LAZY_LOADING_VERTICAL_OFFSET+ "px 0px"
        });

        wrapperObserver.observe(wrapper);
    }else{
        var lazyloadComments = function(){

            if (animateGridThrottleTimeout) {
                clearTimeout(animateGridThrottleTimeout);
            }

            animateGridThrottleTimeout = setTimeout(function() {
                var scrollTop = window.pageYOffset;
                if (wrapper.offsetTop - LAZY_LOADING_VERTICAL_OFFSET < (window.innerHeight + scrollTop)){
                    let postId = wrapper.dataset.postId;
                    getCommentsWrapper(postId, function(){
                        loadFormValidator("#commentForm");
                    });
                    if (wrapper) {
                        document.removeEventListener("scroll", lazyloadComments);
                        window.removeEventListener("resize", animateGrid);
                        window.removeEventListener("orientationChange", animateGrid);
                    }
                }
            }, 20);

        }

        document.addEventListener("scroll", lazyloadComments);
        window.addEventListener("resize", lazyloadComments);
        window.addEventListener("orientationchange", lazyloadComments);
}
}

$(function(){

    body.one('click', replaceBlogDetailGradient);
    body.one('keydown', replaceBlogDetailGradient);
    body.one('mousemove', replaceBlogDetailGradient);
    body.one('touchstart', replaceBlogDetailGradient);

})

function replaceBlogDetailGradient(ev){
    $('.view.view-mask-background').addClass('bg fadeInCarousel');

    body.off('click', null, replaceBlogDetailGradient);
    body.off('keydown', null, replaceBlogDetailGradient);
    body.off('mousemove', null, replaceBlogDetailGradient);
    body.off('touchstart', null, replaceBlogDetailGradient);
}